export * from './redresources.component'